import React, { Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { CustomDelByNote, CustomDelete, EditWithIcon, MinLoader, SimpleTooltip } from 'components';
import { Colors, FindLoad, Images, useModal } from 'utils';
import { remittanceStatusEnums, renderStatusBadge } from '../constants';
import { AddClaimPayment } from '../core';
import { claimActions, claimPaymentActions } from '../../../../store';
import { VOID_REMITTANCE } from '../../../../store/posting/claimPayment/claimPayment.type';
const VERIFY_ACTION_TYPE = 'VERIFY_REMITTANCES';
const VOID_ACTION_TYPE = 'VOID_REMITTANCE';
const DELETE_ACTION_TYPE = 'DELETE_REMITTANCE';

export const ClaimPaymentDetailHeader = ({}) => {
    const remittanceById = useSelector((state) => state.claimPayment.remittanceById);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const info = location?.state;
    const { open, close } = useModal();
    const loader = FindLoad(VERIFY_ACTION_TYPE);

    const handleVerify = () => {
        dispatch(claimPaymentActions.verifyRemittance([remittanceById?.id], remittanceById?.id));
    };

    const handleVoidClaim = () => {
        open(
            <CustomDelByNote
                info="Void This Payment?"
                text="Voiding this payment will mark it as Void and revert all applied claims to unpaid status. This action cannot be undone."
                handleDel={(closingComment) => {
                    dispatch(claimPaymentActions.voidRemittance(remittanceById?.id, { reason: closingComment }));
                }}
                afterSuccess={close}
                required={false}
                innerText={'Void Payment'}
                inputLabel={'Void Reason (optional)'}
                actionType={VOID_ACTION_TYPE}
            />
        );
    };

    return (
        <Fragment>
            <div className="tabs-wrapper">
                <div className="space-between-flex-start" style={{ height: 36 }}>
                    <div className="detail-page-title-box">
                        <p>Payment# </p>
                        <p>{remittanceById?.displayId}</p>
                        {remittanceById?.verified && (
                            <SimpleTooltip title={'This payment has been verified with the bank.'} placement="top-end">
                                <img src={Images.verifiedBadge} alt="verifiedBadge" />
                            </SimpleTooltip>
                        )}
                    </div>
                    <div className="flex-align-center" style={{ gap: 16 }}>
                        <div>{renderStatusBadge(remittanceById?.status, remittanceById?.voidReason)}</div>
                        {remittanceById?.status === remittanceStatusEnums.VOID && (
                            <EditWithIcon
                                id={'secondary-billing'}
                                icon={Images.redTrash}
                                type={'button'}
                                handleClick={() => {
                                    open(
                                        <CustomDelete
                                            info="Delete This Payment?"
                                            text="Are you sure you want to delete this payment? This action cannot be undone."
                                            handleDel={() => dispatch(claimPaymentActions.deleteRemittance(remittanceById?.id))}
                                            actionType={DELETE_ACTION_TYPE}
                                            afterSuccess={() => navigate('/claimPayments')}
                                        />
                                    );
                                }}
                            />
                        )}

                        {!remittanceById?.verified && remittanceById?.status !== remittanceStatusEnums.VOID && (
                            <button onClick={handleVerify} className="verified-btn">
                                {loader?.length ? (
                                    <div style={{ width: 18 }}>
                                        <MinLoader width={'18px'} height={'18px'} margin={'0'} color={'#344054'} position={'relative'} />
                                    </div>
                                ) : (
                                    <img
                                        style={{
                                            filter: 'brightness(0) saturate(100%) invert(24%) sepia(12%) saturate(1228%) hue-rotate(179deg) brightness(93%) contrast(94%)',
                                        }}
                                        src={Images.verified}
                                        alt="verified"
                                    />
                                )}
                                <p>Verify</p>
                            </button>
                        )}

                        {(!info?.activeTab || info?.activeTab === 'Details') && remittanceById?.status !== remittanceStatusEnums.VOID && (
                            <div className="flex-align-center" style={{ gap: 16 }}>
                                <EditWithIcon
                                    handleClick={() =>
                                        open(<AddClaimPayment info={remittanceById} edit={true} />, {
                                            styles: { headerStyle: { display: 'none' } },
                                        })
                                    }
                                />
                            </div>
                        )}

                        {remittanceById?.status !== remittanceStatusEnums.VOID && (
                            <button onClick={handleVoidClaim} className="void-claim-pmt">
                                Void
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </Fragment>
    );
};
